import type { CSSProperties } from 'react';
import MarkReadIconSvg from '../../assets/icons/mark_read.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const MarkReadIcon: React.FC<IconProps> = ({ size = 16, className = '', style = {}, onClick }) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <MarkReadIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default MarkReadIcon;
